import React from 'react';
import { Text, } from 'react-native';
import { styles } from '../../utils/style';
import Flex from '../Flex';
import { Space } from '../Space';
import { NodeGap, useButtonStyle } from './style';
export function Button(props) {
    const { type = 'primary', size = 'small', block = false, shape = 'rect', disable = false, ghost = false, children, icon, style, textStyle, wait, onPress, } = props || {};
    const { themeStyles, sizeStyle, colorStyle, roundStyle, fontStyle, ghostStyle, } = useButtonStyle({
        size,
        block,
        shape,
        ghost,
    });
    const renderChildren = () => {
        const isJsx = React.isValidElement(children);
        if (isJsx)
            return children;
        return (React.createElement(Text, { style: [
                colorStyle[type] || colorStyle['primary'],
                fontStyle[size] || fontStyle['small'],
                styles({
                    alignSelf: 'center',
                }),
                textStyle,
            ] }, children));
    };
    return (React.createElement(Flex, { flex: 'flexCenter', style: [
            themeStyles.base,
            themeStyles[type] || themeStyles['primary'],
            sizeStyle[size] || sizeStyle['small'],
            shape === 'round' ? roundStyle.round : null,
            disable ? styles({ opacity: 0.4 }) : null,
            ghost ? ghostStyle.ghost : null,
            style,
        ], wait: wait, onPress: (e) => {
            if (props.disable)
                return;
            onPress === null || onPress === void 0 ? void 0 : onPress(e);
        }, touchableOpacityStyle: block
            ? {
                alignSelf: 'stretch',
            }
            : {} }, icon ? (React.createElement(Space, { gap: NodeGap[size] || NodeGap['small'] },
        icon,
        renderChildren())) : (renderChildren())));
}
export default Button;
